import { useContext, useState } from 'react';

import { useUpdateEstimateStatusQuery } from '@widgets/EstimateInformation/api/hooks/useUpdateEstimateStatusQuery';
import { EstimateInformationContext } from '@widgets/EstimateInformation/model/context';
import { Status } from '@widgets/EstimateInformation/model/types/types';

export const useGanttModal = () => {
    const { onSetStatus, onCloseGanttModal } = useContext(EstimateInformationContext);
    const updateEstimateStatusMutation = useUpdateEstimateStatusQuery();

    const [modalType, setModalType] = useState<'confirm' | 'form'>('confirm');

    const onChangeStatusInExploitation = async () => {
        onCloseGanttModal();
        const response = await updateEstimateStatusMutation.mutateAsync(Status.IN_EXPLOITATIONS);
        if (response?.response?.data?.status === 'tariff-error') {
            return;
        }
        onSetStatus(Status.IN_EXPLOITATIONS);
        window.location.reload();
    };

    const onSetFormModalType = () => {
        setModalType('form');
    };

    return {
        onSetFormModalType,
        onChangeStatusInExploitation,
        modalType,
    };
};
